import store from '../store'
import { auth } from '../api/firebase'

export default async (to, from, next) => {
    if (store.state.auth.currentUser) {
        next()
    } else {
        if (auth.currentUser) {
            await store.dispatch('auth/SET_AUTH', {
                refresh: true
            })
            next()
        } else {
            next({ name: 'login' })
        }
    }
}
